import { motion } from "framer-motion";

interface ComplianceRingProps {
  score: number;
  size?: number;
  strokeWidth?: number;
}

const ComplianceRing = ({ score, size = 120, strokeWidth }: ComplianceRingProps) => {
  const sw = strokeWidth ?? Math.max(2, Math.round(size / 12));
  const radius = (size - sw) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (score / 100) * circumference;
  const center = size / 2;
  const fontSize = size < 50 ? "text-[9px]" : "text-2xl";

  const getColor = () => {
    if (score >= 75) return "hsl(var(--primary))";
    if (score >= 50) return "hsl(var(--muted-foreground))";
    return "hsl(var(--destructive))";
  };

  return (
    <div className="relative flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={center} cy={center} r={radius} fill="none" stroke="hsl(var(--muted))" strokeWidth={sw} />
        <motion.circle
          cx={center} cy={center} r={radius} fill="none"
          stroke={getColor()} strokeWidth={sw} strokeLinecap="round"
          strokeDasharray={circumference}
          initial={{ strokeDashoffset: circumference }}
          animate={{ strokeDashoffset: offset }}
          transition={{ duration: 1.2, ease: "easeOut", delay: 0.3 }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <motion.span
          className={`${fontSize} font-extrabold text-foreground`}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.8, duration: 0.4 }}
        >
          {score}%
        </motion.span>
      </div>
    </div>
  );
};

export default ComplianceRing;
